import React, { useEffect, useState } from 'react';

const ImagePreload: React.FC<{ imgDir: string | null, imgList: string[], setImagesLoaded: React.Dispatch<React.SetStateAction<boolean>> }> = ({ imgDir, imgList, setImagesLoaded }) => {
  const [images, setImages] = useState<string[]>(imgList);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (images.length === 0) return;

    let loadedCount = 0;

    const imageElements = async () => {
      for (let i = 0; i < images.length; i++) {
        await new Promise<void>((resolve) => {
          const img = new Image();
          const src = `${process.env.PUBLIC_URL}/img/${imgDir ? `${imgDir}/` : ""}${images[i]}`;
          img.src = src;
          img.onload = () => {
            loadedCount += 1;
            setCurrentImageIndex(() => loadedCount);
            if (loadedCount === images.length) {
              setImagesLoaded(true);
            }
            setTimeout(resolve, 50);
          };
        });
      }
    };

    imageElements().catch((error) => {
      console.error('Error preloading images', error);
      alert("画像の読み込みに失敗しました。\nゲームを開始することはできますが、一部の効果が正常に再生されない可能性があります。");
      setImagesLoaded(true);
    });
  }, []);

  return (<div style={{
    height: "48px",
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "center",
    justifyContent: "flex-start",
  }}>
    <div style={{
      color: "white"
    }}>リソースを読み込んでいます... {currentImageIndex}/{images.length}</div>
    {images[currentImageIndex] && (
      <img style={{
        position: "absolute",
        width: "1px",
        height: "1px",
        opacity: "0.1"
      }} src={`./img/${images[currentImageIndex]}`} />
    )}
  </div>);
};

export default ImagePreload;
